import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AuthShell from '../comps/authShell'
import { InputErrorMassage } from '../comps/comps'
import { setSignupDraft } from '../utils/signupDraft'
import * as actions from '../store/authAction'

const AuthOauth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const [error, setError] = useState('')

  useEffect(() => {
    const run = async () => {
      const id = params.get('id')
      const pid = params.get('pid')
      const ticket = params.get('ticket')
      try {
        if (id && pid) {
          await dispatch(actions.auth(id, pid))
          navigate('/', { replace: true })
          return
        }
        if (ticket) {
          const data = await actions.social_ticket(ticket)
          setSignupDraft({
            email: data.email,
            name: data.name || '',
            password: data.password,
            emailVerified: true,
            social: 'github'
          })
          navigate(data.name && data.name.length >= 3 ? '/auth/setup/bio' : '/auth/setup/name', { replace: true })
          return
        }
        setError('Sign in failed')
      } catch (err) {
        setError(err && err.message ? err.message : 'Sign in failed')
      }
    }
    run()
  }, [dispatch, navigate, params])

  return (
    <AuthShell title="Signing in">
      <p className="authStepLabel">{error ? 'Could not finish sign in' : 'Finishing sign in…'}</p>
      {error ? <InputErrorMassage val={'hi'} num={[10, 10]} text={error} /> : null}
      {error ? <p className="googlebuttonss" onClick={() => navigate('/auth')}>Back</p> : null}
    </AuthShell>
  )
}

export default AuthOauth
